export default __webpack_public_path__ + "static/media/users.d80db939.svg";